import {
  DocumentOrganizationKeys,
  GoalFilterDocument,
} from 'shared/types/filter-document';
import { GroupByMode } from 'shared/types/sorting-mode';

export const defaultFilterDocument: GoalFilterDocument = {
  [DocumentOrganizationKeys.SortingMode]: null,
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.None,
  [DocumentOrganizationKeys.Filters]: {},
  [DocumentOrganizationKeys.CollapsedSections]: [],
};
